import { FormProvider, useForm } from 'react-hook-form'
import DriverTrackingForm from '../../../../components/forms/driver-tracking-form/driver-tracking-form.component'
// import DriverLicenseView from './driver-licence-view/driver-licence-view.component'

const DriverTracking = () => {
  const formMethods = useForm()

  return (
    <FormProvider {...formMethods}>
      <DriverTrackingForm />
      {/* <DriverLicenseView /> */}
    </FormProvider>
  )
}

export default DriverTracking
